"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFilterAutoCompleteResponse = exports.createAutoCompleteResponse = void 0;
const createAutoCompleteResult_1 = require("./createAutoCompleteResult");
function createAutoCompleteResponse(data) {
    if (!data.response) {
        throw new Error('The autocomplete data does not contain a response property');
    }
    if (!Object.keys(data.response).length) {
        throw new Error('The autocomplete response is empty');
    }
    const response = data.response;
    const responseResults = response.results.map(createAutoCompleteResult_1.createAutoCompleteResult);
    const inputIntents = response.input ? response.input.queryIntents : [];
    return Object.freeze({
        results: responseResults,
        queryId: response.queryId,
        inputIntents: inputIntents || []
    });
}
exports.createAutoCompleteResponse = createAutoCompleteResponse;
function createFilterAutoCompleteResponse(data) {
    if (!data.response) {
        throw new Error('The autocomplete data does not contain a response property');
    }
    if (!Object.keys(data.response).length) {
        throw new Error('The autocomplete response is empty');
    }
    const response = data.response;
    let isSectioned = false;
    let sections = [];
    let responseResults = [];
    // a filter autocomplete response may have a sections object
    if (response.sections) {
        isSectioned = true;
        sections = response.sections.map((section) => ({
            label: section.label,
            results: section.results.map(createAutoCompleteResult_1.createAutoCompleteResult)
        }));
    }
    else {
        responseResults = response.results.map(createAutoCompleteResult_1.createAutoCompleteResult);
    }
    const inputIntents = response.input ? response.input.queryIntents : [];
    return Object.freeze({
        sectioned: isSectioned,
        sections: sections,
        results: responseResults,
        queryId: response.queryId,
        inputIntents: inputIntents || []
    });
}
exports.createFilterAutoCompleteResponse = createFilterAutoCompleteResponse;
